var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 56,
    viewBox: "0 0 139 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9684 52.0986H0V55.9574H26.9684V52.0986Z",
    fill: "#415DF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9684 44.7705H0V48.6293H26.9684V44.7705Z",
    fill: "#415DF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 37.4004H7.71765V41.2592H19.2941V37.4004Z",
    fill: "#415DF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 30.0293H7.71765V33.8881H19.2941V30.0293Z",
    fill: "#415DF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 22.7021H7.71765V26.561H19.2941V22.7021Z",
    fill: "#415DF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2941 15.3311H7.71765V19.1899H19.2941V15.3311Z",
    fill: "#415DF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9684 7.95996H0V11.8188H26.9684V7.95996Z",
    fill: "#415DF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9684 0.632812H0V4.49163H26.9684V0.632812Z",
    fill: "#415DF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8271 48.6293H71.9734C72.6671 47.4153 73.1874 46.1146 73.5343 44.7705H30.8705V48.6293H30.8271Z",
    fill: "#415DF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7216 30.0293H38.5448V33.8881H71.9734C71.1063 32.4573 70.0223 31.1566 68.7216 30.0293Z",
    fill: "#415DF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5448 22.7021V26.561H68.7216C70.0223 25.477 71.1063 24.1763 71.9301 22.7021H38.5448Z",
    fill: "#415DF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9734 7.95996H30.8705V11.8188H73.5343C73.1874 10.4747 72.6671 9.17397 71.9734 7.95996Z",
    fill: "#415DF1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2263 0.632812H30.8271V4.49163H69.1552C66.4236 1.9769 62.8683 0.632812 59.2263 0.632812Z",
    fill: "#415DF1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1213 15.3311H38.5448V19.1899H50.1213V15.3311Z",
    fill: "#415DF1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9607 19.1899H73.4043C73.7511 17.9325 73.9246 16.6318 73.9246 15.3311H60.9607V19.1899Z",
    fill: "#415DF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1213 37.4004H38.5448V41.2592H50.1213V37.4004Z",
    fill: "#415DF1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9607 37.4004V41.2592H73.9246C73.9246 39.9585 73.7511 38.6578 73.4043 37.4004H60.9607Z",
    fill: "#415DF1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8271 55.9571L59.2263 56.0004C62.9117 56.0004 66.467 54.613 69.1552 52.1416H30.8271V55.9571Z",
    fill: "#415DF1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.917 55.9574L109.261 52.0986H106.573L107.917 55.9574Z",
    fill: "#415DF1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.359 48.6293H110.475L111.819 44.7705H103.971L105.359 48.6293Z",
    fill: "#415DF1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M102.757 41.2592H113.076L114.42 37.4004H101.413L102.757 41.2592Z",
    fill: "#415DF1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.156 33.8881H115.634L117.022 30.0293H98.8118L100.156 33.8881Z",
    fill: "#415DF1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8073 19.1899H105.619L104.275 15.3311H84.8073V19.1899Z",
    fill: "#415DF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.773 11.8188H138.744V7.95996H114.117L112.773 11.8188Z",
    fill: "#415DF1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.675 0.632812L115.331 4.49163H138.744V0.632812H116.675Z",
    fill: "#415DF1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3403 52.0986H77.0896V55.9574H96.3403V52.0986Z",
    fill: "#415DF1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3403 44.7705H77.0896V48.6293H96.3403V44.7705Z",
    fill: "#415DF1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3837 37.4004H84.8073V41.2592H96.3837V37.4004Z",
    fill: "#415DF1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3837 30.0293H84.8073V33.8881H96.3837V30.0293Z",
    fill: "#415DF1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.026 15.3311H111.559L110.215 19.1899H131.026V15.3311Z",
    fill: "#415DF1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M119.493 26.561H131.026V22.7021H119.493H109.001L107.917 25.8239L106.833 22.7021H96.3403H84.8073V26.561H96.3403V23.0056L97.5977 26.561H118.236L119.493 23.0056V26.561Z",
    fill: "#415DF1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.07 30.0293H119.493V33.8881H131.07V30.0293Z",
    fill: "#415DF1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.07 37.4004H119.493V41.2592H131.07V37.4004Z",
    fill: "#415DF1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138.744 44.7705H119.493V48.6293H138.744V44.7705Z",
    fill: "#415DF1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.744 52.0986H119.493V55.9574H138.744V52.0986Z",
    fill: "#415DF1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.061 11.8188L101.717 7.95996H77.0896V11.8188H103.061Z",
    fill: "#415DF1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M100.503 4.49163L99.1586 0.632812H77.0896V4.49163H100.503Z",
    fill: "#415DF1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbm);
export default __webpack_public_path__ + "static/media/IBM.96073b2767001810614435b25a8d9e43.svg";
export { ForwardRef as ReactComponent };